<template>
  <div class="container">
    <CommonFrame 
      :workNo="workNo"
      :btns="btns"
      :node="node"
      :breadcrumb="breadcrumb"
      :endStatus="approvalParams.endStatus"
      :approvalTabStatus="approvalParams.approvalTabStatus"
    >
      <div slot="info">
        <h4>
          <span>退货单号:</span>
          <span>{{id}}</span>
        </h4>
        <span v-for="(item,index) in infosArr" class="padding-span" :key="index">
          <span>
            {{item.name}}
          </span>:
          <span>
            {{item.value}}
          </span>
        </span>
      </div>
      <div slot="tableInfo">
        <div class="cardContainer">
          <lk-card title="退货单信息">
            <div>
              <lk-form :model="formObject" :label-width="140">
                <lk-row>
                  <lk-col span="12">
                    <lk-form-item label="供应商名称：">
                      <span>{{formObject.supplierName}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="12">
                    <lk-form-item label="总金额：">
                      <span>{{formObject.amount}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row>
                  <lk-col span="24">
                    <lk-form-item label="退回商品：">
                      <div>
                        <lk-table :columns="columns" :data="tableData"></lk-table>
                      </div>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row>
                  <lk-col span="24">
                    <lk-form-item label="退货原因：">
                      <span>{{formObject.remark}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row>
                  <lk-col span="24">
                    <lk-form-item label="取消退货原因：">
                      <span>{{formObject.cancelReason}}</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
      </div>
    </CommonFrame>
  </div>
</template>

<script>
import axios from 'axios';
import CommonFrame from '../commonFrame.vue';
import utils from '../../../libs/utils';

export default {
  name: 'Breakage',
  props: {
    approvalParams: {
      type: Object,
    },
  },
  components: {
    CommonFrame,
  },
  data() {
    return {
      columns: [
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '入库时间', key: 'purchaseTime', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '商品名称', key: 'approvedName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 },
        { title: '有效期', key: 'expiryDate', minWidth: 116 },
        { title: '包装单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '原验收数量', key: 'inspectionPassNum', minWidth: 116 },
        { title: '库存数量', key: 'inventoryTotalNum', minWidth: 116 },
        { title: '退货数量', key: 'num', minWidth: 116 },
        { title: '单价', key: 'refundPrice', minWidth: 116 },
        { title: '退货金额', key: 'amount', minWidth: 116 },
      ],
      tableData: [],
      formObject: {
        supplierName: '',
        amount: '',
        remark: '',
        cancelReason: '',
      },
      workNo: '',
      node: '',
      breadcrumb: [
        {
          name: 'work',
          title: '审批列表',
        },
        {
          name: 'approvalEdit',
          title: '供应商退货取消审批',
        },
      ],
      btns: [
        {
          name: 'reject',
          text: '驳回',
          type: 'default',
        },
        {
          name: 'pass',
          text: '通过',
          type: 'primary',
        },
      ],
      infosArr: [],
    };
  },
  methods: {
    getSupplierRefundInfo(businessUrl) {
      axios.get(businessUrl).then((res) => {
        let data = res.data.data;
        data.purchaseRefundDetailList.forEach((item) => {
          item.expiryDate = utils.exchangeTime(item.expiryDate);
          item.purchaseTime = utils.exchangeTime(item.purchaseTime);
        });
        this.tableData = data.purchaseRefundDetailList;
        this.formObject.supplierName = data.purchaseRefund.supplierName;
        this.formObject.remark = data.purchaseRefund.remark || '无';
        this.formObject.amount = data.purchaseRefund.amount;
        this.formObject.cancelReason = data.purchaseRefund.cancelReason;
        this.id = data.purchaseRefund.code;
        this.infosArr.push(
          { name: '门店名称', value: data.purchaseRefund.storeName },
          { name: '提交时间', value: utils.exchangeTimeToSecond(data.purchaseRefund.createTime) },
          { name: '提交人', value: data.purchaseRefund.createUserName });
        }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.workNo = this.approvalParams.workNo;
    this.node = this.approvalParams.node;
    this.getSupplierRefundInfo(this.approvalParams.businessUrl);
  },
};
</script>
